function diffInMinutes(date) {
  const now = new Date();
  const then = new Date(date);
  return Math.floor((now - then) / 60000);
}

function formatWaitingTime(totalMinutes) {
  if (totalMinutes < 60) {
    return `${totalMinutes} min`;
  }

  const totalHours = Math.floor(totalMinutes / 60);

  if (totalHours < 24) {
    const remainingMinutes = totalMinutes % 60;

    if (remainingMinutes === 0) {
      return `${totalHours}h`;
    }

    return `${totalHours}h ${remainingMinutes}min`;
  }

  const totalDays = Math.floor(totalHours / 24);
  return totalDays === 1
    ? `1 dia`
    : `${totalDays} dias`;
}

function getPriority(totalMinutes) {
  if (totalMinutes >= 60) return "alta";
  if (totalMinutes >= 15) return "media";
  return "baixa";
}

export function buildPriorityQueue(conversations) {
  return conversations
    .filter((c) => !c.responded)
    .map((c) => {
      const minutesWaiting = diffInMinutes(c.lastMessageAt);

      return {
        id: c.id,
        name: c.name,
        interest: c.stage || "Interesse não informado",
        lastMessage: c.lastUserMessage || "Última mensagem recebida",
        minutesWaiting,
        waitingLabel: formatWaitingTime(minutesWaiting),
        priority: getPriority(minutesWaiting),
      };
    })
    .sort((a, b) => b.minutesWaiting - a.minutesWaiting);
}